import {css} from '@emotion/react'

import {
    AiProvider,
    ButtonAttach,
    ButtonChooseTemplate,
    ButtonMain,
    ButtonPromptHistory,
    Chat,
} from '@/biz/ai'

import {Scene} from './Scene.jsx'
import {Template} from './Template.jsx'
import {useAiChat, useAiWorkflow} from './useAi.mjs'

const cssAiCommon = css({
    display: 'grid',
    gridTemplateRows: 'auto auto auto 1fr',
    position: 'relative',
    overflow: 'hidden',
})

const cssScene = css({
    textAlign: 'center',
    borderBottom: '1px solid #e8e8e8',
})

const cssTemplate = css({
    textAlign: 'center',
})

const cssTitle = css({
    textAlign: 'center',
    color: '#999',
})

const cssChat = css({
    width: 'min(100%, 1200px)',
    margin: '0 auto',
})

export const normalizeUseAiArgs = ({
    bizMap = '{}',
    defaultDraft,
    sVer,
    ...args
}) => ({
    biz: bizMap && JSON.parse(bizMap),
    defaultDraft: defaultDraft && JSON.parse(defaultDraft),
    sVer: sVer && Number(sVer),
    ...args,
})

export const Common = ({ai, leftTools, rightTools, tools, ...props}) => {
    const _tools = tools ?? [
        <>
            <ButtonChooseTemplate />
            {leftTools}
        </>,

        <>
            <ButtonPromptHistory />
            <ButtonAttach />
            <ButtonMain />
            {rightTools}
        </>
    ]

    return (
        <div
            css={cssAiCommon}
            {...props}
        >
            <AiProvider value={ai}>
                <Scene css={cssScene} />
                <Template css={cssTemplate} />

                <div css={cssTitle}>
                    {ai.getTitle()}
                </div>

                <Chat
                    css={cssChat}
                    tools={_tools}
                />
            </AiProvider>
        </div>
    )
}

export const CommonChat = ({
    bizMap,
    defaultDraft,
    prjId,
    scene,
    sVer,
    title,
    ...props
}) => {
    const ai = useAiChat(normalizeUseAiArgs({
        bizMap,
        defaultDraft,
        prjId,
        scene,
        sVer,
        title,
    }))

    return (
        <Common
            ai={ai}
            {...props}
        />
    )
}

export const CommonWorkflow = ({
    bizMap,
    defaultDraft,
    prjId,
    scene,
    sVer,
    title,
    ...props
}) => {
    const ai = useAiWorkflow(normalizeUseAiArgs({
        bizMap,
        defaultDraft,
        prjId,
        scene,
        sVer,
        title,
    }))

    return (
        <Common
            ai={ai}
            {...props}
        />
    )
}
